export default __webpack_public_path__ + "b0f245a3400d9267af4e4db3be08b4ad.svg";